import { Box, Theme } from "@outschool/backpack";
import { ApolloError } from "@outschool/ui-apollo";
import { PageAlerts } from "@outschool/ui-components-website";
import React from "react";

import SectionStartReminder from "../../containers/SectionStartReminder";
import { UserMode, UserModeProvider } from "../../lib/UserMode";
import AccountBanner from "../AccountBanner";
import Footer from "../Footer";
import { GiftCardModal } from "../giftCards/GiftCardModal";
import Header from "../nav/Header";
import ReviewReminderTopNoticeBar from "../ReviewReminderTopNoticeBar";
import SignupModal from "../SignupModal";
import TimedTopNoticeBar from "../TimedTopNoticeBar";
import TopNoticeBar from "../TopNoticeBar";

export type SimpleLayoutProps = {
  children?: React.ReactNode;
  error?: string | ApolloError;
  narrowColumn?: boolean;
  narrowPaddedColumn?: boolean;
  grayBackground?: boolean;
  hideFooter?: boolean;
  hideReviewReminder?: boolean;
  hideAccountBanner?: boolean;
  sx?: React.CSSProperties;
  contentSx?: React.CSSProperties;
  userMode?: UserMode;
  allowGlobalNavbar?: boolean;
};

const SimpleLayout = React.forwardRef<HTMLDivElement, SimpleLayoutProps>(
  (
    {
      children,
      error,
      narrowColumn,
      narrowPaddedColumn,
      grayBackground,
      hideFooter = false,
      hideReviewReminder = false,
      hideAccountBanner = false,
      sx = {},
      contentSx = {},
      userMode = null,
      allowGlobalNavbar = false
    },
    ref: React.Ref<HTMLDivElement>
  ) => {
    return (
      <UserModeProvider value={userMode}>
        <Box>
          <Header allowGlobalNavbar={allowGlobalNavbar} />
          <TopNoticeBar topNotice={error} />
          <TimedTopNoticeBar />
          {!hideAccountBanner && <AccountBanner />}
          <SectionStartReminder />
          {!hideReviewReminder && <ReviewReminderTopNoticeBar />}
          <PageAlerts />
        </Box>
        <Box
          sx={{
            minHeight: "100%",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            ...((grayBackground || narrowColumn || narrowPaddedColumn) && {
              backGroundColor: "#FAFAFA"
            }),
            ...sx
          }}
          ref={ref}
        >
          <Box
            sx={(theme: Theme) => ({
              flexGrow: 1,
              ...(narrowColumn && {
                maxWidth: "750px",
                position: "relative",
                width: "100%",
                marginLeft: "auto",
                marginRight: "auto",
                boxSizing: "border-box",
                backgroundColor: "#FFF"
              }),
              ...(narrowPaddedColumn && {
                maxWidth: "750px",
                position: "relative",
                width: "100%",
                marginLeft: "auto",
                marginRight: "auto",
                boxSizing: "border-box",
                backgroundColor: "#FFF",
                paddingY: "2em",
                paddingX: "1em",
                [theme.breakpoints.up("md")]: {
                  paddingX: "2em"
                }
              }),
              ...contentSx
            })}
          >
            {children}
          </Box>
          {!hideFooter && <Footer />}
          <SignupModal />
          <GiftCardModal />
        </Box>
      </UserModeProvider>
    );
  }
);

export default SimpleLayout;
